@if (isInitialized) {
  <oe-chart [title]="'GENERAL.CONSUMPTION' | translate" [(showPhases)]="showPhases" [period]="service.historyPeriod.value"
    >
    <consumptionchart [isOnlyChart]="true">
    </consumptionchart>
  </oe-chart>
}
@if (isInitialized) {
  <oe-footer-subnavigation [navigationOptions]="navigationButtons"></oe-footer-subnavigation>
}
